/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignRoleRequest } from '../models/AssignRoleRequest';
import type { BaseDataResponse_dict_ } from '../models/BaseDataResponse_dict_';
import type { BaseDataResponse_UserProfileDto_ } from '../models/BaseDataResponse_UserProfileDto_';
import type { BaseDataResponse_UserWithRolesDto_ } from '../models/BaseDataResponse_UserWithRolesDto_';
import type { BaseListDataResponse_UserWithRolesDto_ } from '../models/BaseListDataResponse_UserWithRolesDto_';
import type { ChangePasswordAuthRequest } from '../models/ChangePasswordAuthRequest';
import type { CreateUserWithPasswordRequest } from '../models/CreateUserWithPasswordRequest';
import type { FillUserProfileRequest } from '../models/FillUserProfileRequest';
import type { RoleName } from '../models/RoleName';
import type { UpdateUserStatusRequest } from '../models/UpdateUserStatusRequest';
import type { UserStatus } from '../models/UserStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Get Current User
     * Получение данных текущего авторизованного пользователя
     * @returns BaseDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static getCurrentUserApiUsersMeGet(): CancelablePromise<BaseDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/me',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create User Endpoint
     * Создание нового пользователя
     * @param requestBody
     * @returns BaseDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static createUserEndpointApiUsersPost(
        requestBody: CreateUserWithPasswordRequest,
    ): CancelablePromise<BaseDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: role_not_found`,
                409: `Code: user_already_exists`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Search Users
     * Поиск пользователей
     * @param email Фильтр по email (частичное совпадение)
     * @param username Фильтр по username (частичное совпадение)
     * @param fullName Фильтр по full_name (частичное совпадение)
     * @param status Фильтр по статусу
     * @param roleName Фильтр по роли
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static searchUsersApiUsersGet(
        email?: (string | null),
        username?: (string | null),
        fullName?: (string | null),
        status?: (UserStatus | null),
        roleName?: (RoleName | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users',
            query: {
                'email': email,
                'username': username,
                'full_name': fullName,
                'status': status,
                'role_name': roleName,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get User
     * Получение пользователя по ID
     * @param userId
     * @returns BaseDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static getUserApiUsersUserIdGet(
        userId: string,
    ): CancelablePromise<BaseDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Assign Role To User
     * Назначение роли пользователю
     * @param userId
     * @param requestBody
     * @returns BaseDataResponse_dict_ Successful Response
     * @throws ApiError
     */
    public static assignRoleToUserApiUsersUserIdRolesPost(
        userId: string,
        requestBody: AssignRoleRequest,
    ): CancelablePromise<BaseDataResponse_dict_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{user_id}/roles',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Possible errors: user_not_found, role_not_found`,
                409: `Code: user_role_already_assigned`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Remove Role From User
     * Удаление роли у пользователя
     * @param userId
     * @param roleName
     * @returns BaseDataResponse_dict_ Successful Response
     * @throws ApiError
     */
    public static removeRoleFromUserApiUsersUserIdRolesRoleNameDelete(
        userId: string,
        roleName: RoleName,
    ): CancelablePromise<BaseDataResponse_dict_> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{user_id}/roles/{role_name}',
            path: {
                'user_id': userId,
                'role_name': roleName,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Possible errors: user_not_found, role_not_found`,
                409: `Code: user_role_not_assigned`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Block User Endpoint
     * Блокировка пользователя
     * @param userId
     * @returns BaseDataResponse_dict_ Successful Response
     * @throws ApiError
     */
    public static blockUserEndpointApiUsersUserIdBlockPost(
        userId: string,
    ): CancelablePromise<BaseDataResponse_dict_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{user_id}/block',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Add Password Auth Endpoint
     * Добавление пользователю метода аутентификации PASSWORD
     * @param userId
     * @returns BaseDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static addPasswordAuthEndpointApiUsersUserIdPasswordAuthPost(
        userId: string,
    ): CancelablePromise<BaseDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{user_id}/password-auth',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                409: `Code: password_auth_already_exists`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update User Status
     * Обновление статуса пользователя
     * @param userId
     * @param requestBody
     * @returns BaseDataResponse_UserWithRolesDto_ Successful Response
     * @throws ApiError
     */
    public static updateUserStatusApiUsersUserIdStatusPut(
        userId: string,
        requestBody: UpdateUserStatusRequest,
    ): CancelablePromise<BaseDataResponse_UserWithRolesDto_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{user_id}/status',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Fill User Profile Endpoint
     * Заполнение профиля пользователя (создание или обновление)
     * @param userId
     * @param requestBody
     * @returns BaseDataResponse_UserProfileDto_ Successful Response
     * @throws ApiError
     */
    public static fillUserProfileEndpointApiUsersUserIdProfilePost(
        userId: string,
        requestBody: FillUserProfileRequest,
    ): CancelablePromise<BaseDataResponse_UserProfileDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{user_id}/profile',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Change Password Auth Endpoint
     * Смена пароля текущего пользователя
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static changePasswordAuthEndpointApiUsersMePasswordAuthChangePost(
        requestBody: ChangePasswordAuthRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/me/password-auth/change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Possible errors: incorrect_password, no_password_auth`,
                401: `Code: authentication_error`,
                404: `Code: user_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
